const axios = require('axios');
import apiUrl from '../../api.config';

const TAG_CATEGORY_TOPIC_API_URL = `${apiUrl}tagCategoryTopic`;

const TagCategoryTopicService = {
    getBySchool() {
        return axios.get(TAG_CATEGORY_TOPIC_API_URL + '/getBySchool', {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    },
    add(tagCategoryTopicData) {
        return axios.post(TAG_CATEGORY_TOPIC_API_URL + '/create', tagCategoryTopicData, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    },
    update(tagCategoryTopicData) {
        return axios.post(TAG_CATEGORY_TOPIC_API_URL + '/update', tagCategoryTopicData, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    },
    delete(tagCategoryTopicIds) {
        return axios.post(TAG_CATEGORY_TOPIC_API_URL + '/delete', tagCategoryTopicIds, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    }
}

export default TagCategoryTopicService;
